import { gql } from "@apollo/client";

export const CHARGER_ASSET_DETAILS_FRAGMENT = gql`
  fragment ChargerAssetDetails on SalesforceCharger {
    account_id
    adoption_key
    ampol_installed_messaged
    ampol_installed_messaged_timestamp
    charging_priority_group
    circuit_amp_limit
    circuit_phases
    city
    country
    heartbeat_interval
    evos_custom_status
    firmware_version
    iccid
    id
    imei
    imsi
    installation_customer_email
    installation_date
    installation_description
    installation_ref
    installer
    last_boot_notification
    last_comms
    last_heartbeat
    last_status_notification
    latitude
    longitude
    manufacturer
    mode
    model
    name
    ocpp_firmware_status
    ocpp_id
    ocpp_server
    ocpp_status
    ocpp_status_errorcode
    owner_id
    payments_enabled
    postcode
    province
    meterSerialNumber
    meterType
    serial
    serviced_by
    session_limit
    site
    site_disabled
    site_limit
    status
    street_address
    suburb
    time_zone
    vid_id
    vid_vin
    vpn_ip
  }
`;
